// src/index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
// Import i18n configuration first to ensure it's initialized before the app
import "./i18n";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
